export class CustomError extends Error {
  customData: any;
  ignoreError: boolean;
  constructor(customData: any, ignoreError: boolean = false, ...params: any[]) {
    super(...params);
    this.customData = customData;
    this.ignoreError = ignoreError;
  }
}